import { Alert, Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { getPartnerUiCapabilities } from 'utils/partnerUiCapabilities';

// ==============================|| SETTINGS LAYOUT ||============================== //

const readOnlySx = {
  '& button[type="submit"], & .MuiButton-root[type="submit"]': {
    opacity: 0.6,
    pointerEvents: 'none',
    cursor: 'not-allowed !important'
  }
};

const SettingsLayout = () => {
  const caps = getPartnerUiCapabilities();
  const isReadOnly = caps.isPartnerSession && caps.canViewDeviceSettings && !caps.canEditDeviceSettings;

  return (
    <>
      {isReadOnly && (
        <Box sx={{ width: '100%', mb: 2 }}>
          <Alert severity="info">
            These device settings are read-only. Values are visible but cannot be edited.
          </Alert>
        </Box>
      )}
      <Box
        sx={{ display: 'contents', ...(isReadOnly ? readOnlySx : {}) }}
        onSubmitCapture={(event) => {
          if (!isReadOnly) return;
          event.preventDefault();
          event.stopPropagation();
        }}
      >
        <Outlet />
      </Box>
    </>
  );
};

export default SettingsLayout;
